export enum FileUploadType {
  File = 'file',
  Link = 'link',
}
